export type CustomerStatus = "new" | "active" | "inactive" | "unsubscribed";

export const STATUS_OPTIONS: CustomerStatus[] = ["new", "active", "inactive", "unsubscribed"];

export const STATUS_LABEL: Record<CustomerStatus, string> = {
  new: "New",
  active: "Active",
  inactive: "Inactive",
  unsubscribed: "Unsubscribed",
};

export const STATUS_BADGE_CLASS: Record<CustomerStatus, string> = {
  new: "bg-primary/10 text-primary border-primary/20",
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  inactive: "bg-muted text-muted-foreground border-border",
  unsubscribed: "bg-destructive/10 text-destructive border-destructive/20",
};

export const formatDate = (iso: string | null | undefined) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const isValidEmail = (e: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim());
